import React from 'react';
import {
  Plane, Truck, Ship, AlertTriangle, FileText, FileCheck,
  Diamond, Layers, ArrowLeftRight, MapPin, Package, Bell, Shield,
  Globe, Zap, ShieldCheck, Radio, UserCheck
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const AirFreight = () => {
  return (
    <ServicePageTemplate
      heroTitle="Air Freight"
      heroImage="/img/air-freight.jpg"
      slug="air-freight"
      introText={[
        'Denver Logistics Private Limited provides customer-specific air freight solutions for businesses of all sizes.',
        'Understanding that air freight is a premium and time-critical service, we focus on fast transit, secure cargo handling, and continuous communication throughout the shipping process.',
        'Backed by a strong global network of airline partners and logistics agents, we ensure reliable and efficient deliveries to major destinations across the world.',
      ]}
      services={[
        'Airport to Airport',
        'Inland Transportation',
        'Air-Sea Shipment',
        'DGR Handling',
        'Import / Export Docs',
        'Customs Clearance (O&D)',
        'Air Freight Express & Valuables',
        'Cargo Consolidation',
        'Door-to-Door Delivery',
        'Cargo Tracking Service',
        'Packing & Labelling',
        'Prompt Arrival Notification',
        'Cargo Insurance',
      ]}
      serviceIcons={[
        Plane, Truck, Ship, AlertTriangle, FileText, FileCheck,
        Diamond, Layers, ArrowLeftRight, MapPin, Package, Bell, Shield
      ]}
      benefits={[
        { title: 'Global Network', description: 'Strong global network of airline partners and logistics agents.' },
        { title: 'Fast & Reliable', description: 'Premium and time-critical solutions with fast and reliable transit.' },
        { title: 'Secure Handling', description: 'Strict safety measures and best practices for secure cargo handling.' },
        { title: 'Real-time Updates', description: 'Continuous communication and real-time tracking throughout the journey.' },
        { title: 'Customer Focused', description: 'Customized solutions tailored to your business requirements.' },
      ]}
      benefitIcons={[Globe, Zap, ShieldCheck, Radio, UserCheck]}
      callout={{
        eyebrow: 'TIME IS PRECIOUS. WE DELIVER ON TIME.',
        sub: 'Fast transit. Secure handling.',
        ctaLabel: 'TALK TO OUR AIR FREIGHT TEAM',
      }}
      faq={[
        { q: 'What is chargeable weight in air freight?', a: 'Chargeable weight is the greater of the actual gross weight or the volumetric (dimensional) weight of a shipment. Volumetric weight is calculated as Length × Width × Height (cm) ÷ 6000. Airlines charge based on whichever is higher.' },
        { q: 'Which airports does Denver Logistics cover?', a: 'We cover all major international cargo airports through our global network of airline partners and logistics agents. Key hubs include Chennai, Mumbai, Delhi, Dubai, Frankfurt, London, Singapore, Hong Kong, and JFK among many others.' },
        { q: 'How are DGR (Dangerous Goods) shipments handled?', a: 'All DGR shipments are handled by our certified team in full compliance with IATA Dangerous Goods Regulations. This includes proper classification, packaging, labelling, documentation, and carrier coordination.' },
        { q: 'What is the typical transit time for air freight?', a: 'Transit times vary by route and service level. Express services can deliver within 1-3 days to major destinations. Standard air freight typically takes 3-7 days depending on the origin and destination.' },
        { q: 'Can you handle time-critical and express shipments?', a: 'Yes. We offer Air Freight Express & Valuables services for urgent, time-critical, and high-value cargo with priority handling, dedicated tracking, and prompt arrival notification.' },
      ]}
    />
  );
};

export default AirFreight;
